import { Button, Space, Typography } from 'antd';
import React, { useState } from 'react';
import { ArrowLeftOutlined, RobotOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { useQuery } from '@apollo/client';
import { ResourceItem, ResourceSelector } from './components/ResourceSelector';
import { PARTNER_OPTIONS } from './constants';
import { PlaygroundContext } from './context/PlaygroundContext';
import { GET_AGENTS } from './graphql/mutations';

const { Title } = Typography;

const AgentInteractionContent: React.FC = () => {
  const { setCurrentView } = React.useContext(PlaygroundContext);
  const [selectedAgentId, setSelectedAgentId] = useState<string>('');
  const [selectedPartner, setSelectedPartner] = useState<string>('');
  const { data: agentsData, loading: agentsLoading } = useQuery<{
    agentsList: ResourceItem[];
  }>(GET_AGENTS, {
    fetchPolicy: 'cache-first'
  });

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#f5f5f5',
        padding: '20px'
      }}
    >
      <div style={{ maxWidth: 1600, margin: '0 auto' }}>
        <div style={{ marginBottom: 32 }}>
          <Button
            icon={<ArrowLeftOutlined />}
            onClick={() => setCurrentView('main')}
            style={{
              borderRadius: 20,
              border: 'none',
              background: 'white',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              padding: '6px 20px',
              height: 'auto',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              transition: 'all 0.3s ease',
              fontSize: 14,
              fontWeight: 500
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)';
              e.currentTarget.style.transform = 'translateY(-1px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
          >
            Back to Main Menu
          </Button>
        </div>

        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <Space direction="vertical" size={8}>
            <RobotOutlined style={{ fontSize: 32, color: '#52c41a' }} />
            <Title level={3} style={{ margin: 0 }}>
              AI Agent Interaction
            </Title>
          </Space>
        </div>

        <ResourceSelector
          type="agent"
          title="Select an Agent"
          items={agentsData?.agentsList || []}
          loading={agentsLoading}
          onItemSelect={setSelectedAgentId}
          selectedItemId={selectedAgentId}
          partners={PARTNER_OPTIONS}
          selectedPartner={selectedPartner}
          onPartnerSelect={setSelectedPartner}
          fullWidthAfterSelection
        />
      </div>
    </div>
  );
};

export const AgentInteraction: React.FC = () => {
  return <AgentInteractionContent />;
};

export default AgentInteraction;
